import React, { ReactNode } from 'react';
import { LoadingIndicator, OccupyFreeSpace } from '../../toolympus/components/primitives';
import { useAppActions } from '../../AppActionsProvider';
import { ResolvedMarkerX, TaskItem, TaskListWrapper } from './TaskDisplay';
import { useProjectResolvedTasks } from './useProjectResolvedTasks';
import { TasksListHeader } from './ProjectTasksList';

interface Props {
  projectId: string;
  headerButtons?: ReactNode;
  filter?: string;
}

export const ProjectResolvedTasksList = (props: Props) => {
  const data = useProjectResolvedTasks(props.projectId);

  const actions = useAppActions();

  // Применяем фильтр
  const normalizedFilter = props.filter?.trim().toLowerCase() || "";
  const filteredTasks = data.data.filter(t => {
    if (!normalizedFilter) return true;
    return t.title.toLowerCase().includes(normalizedFilter);
  });

  return (<>
    <TasksListHeader>
      Задачи завершенные
      {data.isLoading && <LoadingIndicator className="loader" />}

      <OccupyFreeSpace />

      {props.headerButtons}
    </TasksListHeader>

    <TaskListWrapper>
      {filteredTasks.map(t => (
        <TaskItem
        key={t._id}
        isResolved={!!t.resolved_at}
        onClick={() => actions.openTask(t._id)}>
          {t.title}
          {!!t.resolved_at && <ResolvedMarkerX />}
        </TaskItem>
      ))}
    </TaskListWrapper>
  </>
  );
}